import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { LiteSlateEditor } from "../../lite-slate-editor"
import { InheritedThemeProvider } from "@convertkit/editor"

const styles = `
  @media only screen and (max-width:600px) {
    .ck-twocolumnslargecta td {
      display: block !important;
      width: 100% !important;
      padding: 0 !important;
    }
  }
`

function ThemeWrapper({ headingColor, textColor, children }) {
  const theme = {
    h1: {
      color: headingColor
    },
    h2: {
      color: headingColor
    },
    h3: {
      color: headingColor
    },
    h4: {
      color: headingColor
    },
    h5: {
      color: headingColor
    },
    h6: {
      color: headingColor
    },
    paragraph: {
      color: textColor
    }
  }

  return (
    <InheritedThemeProvider theme={theme}>{children}</InheritedThemeProvider>
  )
}

export function TwoColumnsLargeCTA({ block_id, properties }) {
  const { children } = useBlocks(block_id)

  const containerStyle = {
    borderTopLeftRadius: properties.borderTopLeftRadius,
    borderTopRightRadius: properties.borderTopRightRadius,
    borderBottomLeftRadius: properties.borderBottomLeftRadius,
    borderBottomRightRadius: properties.borderBottomRightRadius,
    borderTopWidth: properties.borderTopWidth,
    borderRightWidth: properties.borderRightWidth,
    borderBottomWidth: properties.borderBottomWidth,
    borderLeftWidth: properties.borderLeftWidth,
    borderColor: properties.borderColor,
    borderStyle: "solid",
    overflow: "hidden"
  }

  const padding = {
    paddingLeft: properties.horizontalPadding,
    paddingRight: properties.horizontalPadding,
    paddingTop: properties.verticalPadding,
    paddingBottom: properties.verticalPadding
  }

  return (
    <div
      className="ck-twocolumnslargecta ck-layout-block-template"
      style={containerStyle}
    >
      <table border="0" cellPadding="0" cellSpacing="0" width="100%">
        <tbody>
          <tr>
            <td
              bgcolor={properties.backgroundColorLeft}
              width="50%"
              style={{
                backgroundImage: `url(${properties.leftImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center"
              }}
            >
              <div style={padding}>
                <ThemeWrapper
                  headingColor={properties.headingColorLeft}
                  textColor={properties.textColorLeft}
                >
                  <LiteSlateEditor block_id={children[0].block_id} />
                </ThemeWrapper>
              </div>
            </td>
            <td
              bgcolor={properties.backgroundColorRight}
              width="50%"
              style={{
                backgroundImage: `url(${properties.rightImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center"
              }}
            >
              <div style={padding}>
                <ThemeWrapper
                  headingColor={properties.headingColorRight}
                  textColor={properties.textColorRight}
                >
                  <LiteSlateEditor block_id={children[1].block_id} />
                </ThemeWrapper>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <style>{styles}</style>
    </div>
  )
}
